// import React from "react";

// // Badge Component
// export const Badge = ({ text }) => {
//   let textClass = "";

//   if (
//     text === "Project Created" ||
//     text === "Project Setup Completed" ||
//     text === "Form Submission in  Progress"||
//     text === "Audit in  Progress"||
//     text === "Report Generated" ||
//     text === "Audit Completed" ||
//     text === "Audit Requested" ||
//     text === "In-Process" ||
//     text === "Closed" ||
//     text === "Active"
//   ) {
//     textClass = "bg-[#6AA4F759]  border border-[#6AA4F7] text-black";
//   } else if (
//     text === "Project Setup Pending" ||
//     text === "Audit In Progress" ||
//     text === "Open"
//   ) {
//     textClass = "bg-[#E8C45859] border border-[#E8C458]";
//   } else if (text === "Form Submitted" || text === "Report Requested") {
//     textClass = "bg-red-200 text-red-600";
//   } else if (text === "Forms Submitted") {
//     textClass = "bg-[#54AEC259] border border-[#54AEC2] ";
//   } else if (text === "Inactive") {
//     textClass = "bg-[#95BFCF] text-[#000000] border border-[#0475A3] ";
//   } else if (text === "Form Submission In Progress") {
//     textClass = "bg-[#EAA89D59] text-[#000000] border border-[#EAA89D] w-[73%]";
//   } else if (text === "Project Assigned") {
//     textClass = "bg-[#45827659] text-[#000000] border border-[#458276] ";
//   } else if (text === "In Process") {
//     textClass = "bg-[#45827659] text-[#000000] border border-[#458276] ";
//   } else if (text === "Audit in Progress") {
//     textClass = "bg-[#45827659] text-[#000000] border border-[#458276] ";
//   }
//   const inputStyle =
//     "text-[11px] font-normal py-1 text-center w-[150px] rounded-md ";

//   return (
//     <div className={`${inputStyle} ${textClass}`} data-value={text}>
//       {text}
//     </div>
//   );
// };

import React from "react";

// Badge Component
export const Badge = ({ text, textSize = "text-[11px]", widthsize }) => {
  let textClass = "";

  const statusMap = {
    "Project Assigned": "bg-[#C7DFD9] text-[#1B6B61] border border-[#458276]",
    "Project Setup Pending":
      "bg-[#F9EFC7] text-[#8A6D3B] border border-[#E8C458]",
    "Project Setup Completed":
      "bg-[#D1E3FF] text-[#31708F] border border-[#6AA4F7]",
    "In Progress": "bg-[#F9D6D1] text-[#A94442] border border-[#EAA89D]",
    "Forms Submitted": "bg-[#D1EEF2] text-[#1B6B61] border border-[#54AEC2]",
    "Report Requested": "bg-[#C7DFD9] text-[#1B6B61] border border-[#458276]",
    "Report Generated": "bg-[#F9EFC7] text-[#8A6D3B] border border-[#E8C458]",
    "Audit Requested": "bg-[#D1E3FF] text-[#31708F] border border-[#6AA4F7]",
    "Audit In Progress": "bg-[#F9D6D1] text-[#A94442] border border-[#EAA89D]",
    "Audit Completed": "bg-[#94B8AF] text-[#1B6B61] border border-[#458276]",
  };

  textClass =
    statusMap[text] || "bg-[#C7DFD9] text-[#1B6B61] border border-[#458276]";

  const inputStyle = `${textSize} font-normal py-1 text-center rounded-md ${widthsize || "w-[170px]"}`;

  return (
    <div
      className={`${inputStyle} ${textClass} text-center`}
      data-value={text}
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
      title=""
    >
      {text}
    </div>
  );
};
